import { Color } from './color.js'

export * from './color.js'

export default Color
